(function () {
  function initHero(root) {
    if (!root || root.dataset.mmHeroBound === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mm-hero-slide]'));
    if (slides.length < 2) return;

    root.dataset.mmHeroBound = 'true';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mm-hero-dot]'));
    var index = Math.max(
      0,
      slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      })
    );
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(next) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[index].hidden = true;
      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].removeAttribute('aria-current');
      }

      index = (next + slides.length) % slides.length;

      slides[index].hidden = false;
      slides[index].classList.add('is-active');
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-current', 'true');
      }
    }

    function next() {
      goTo(index + 1);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay || reduced) return;
      timer = window.setInterval(next, speed);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(i)) return;
        goTo(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var startX = 0;
    root.addEventListener(
      'touchstart',
      function (e) {
        startX = e.changedTouches[0].clientX;
        stop();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          goTo(index + (dx < 0 ? 1 : -1));
        }
        start();
      },
      { passive: true }
    );

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-mm-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var hero = section.querySelector('[data-mm-hero]');
    if (hero) {
      delete hero.dataset.mmHeroBound;
      initHero(hero);
    }
  });
})();
